import "./CarrinhoItemDesktop.css";

export default function CarrinhoItemDesktop({

    produto,

    saldo,

    quantidade,
    mensagem,
    tipoMensagem,

    caixa,
    pesoPorPeca,
    pesoCaixa,
    pesoPeca,

    precoUnitario,
    subtotal,

    aumentar,
    diminuir,
    remover,
    alterarQuantidade,

}) {

    return (

        <article className="carrinhoItemDesktop-item">

            {/* PRODUTO */}

            <div className="carrinhoItemDesktop-produto">

                <div className="carrinhoItemDesktop-foto">

                    {produto.foto ? (

                        <img
                            src={produto.foto}
                            alt={produto.descricao}
                        />

                    ) : (

                        <div className="carrinhoItemDesktop-semFoto">
                            Sem imagem
                        </div>

                    )}

                </div>

                <div className="carrinhoItemDesktop-info">

                    <h3>
                        {produto.descricao}
                    </h3>

                    <div className="carrinhoItemDesktop-pesos">

                        {pesoCaixa > 0 && (

                            <span>
                                CX: {pesoCaixa.toLocaleString("pt-BR")} kg
                            </span>

                        )}

                        {pesoCaixa > 0 && pesoPeca > 0 && (
                            <span> • </span>
                        )}

                        {pesoPeca > 0 && (

                            <span>
                                Unid.: {pesoPeca.toLocaleString("pt-BR")} kg
                            </span>

                        )}

                        {pesoCaixa === 0 &&
                            pesoPeca === 0 && (

                                <span>
                                    Peso: {Number(produto.pesol).toLocaleString("pt-BR")} kg
                                </span>

                            )}

                        {Number(produto.corrigepreco) === 1 && (

                            <div className="carrinhoItemDesktop-pesoVariavel">
                                PRODUTO COM PESO VARIÁVEL
                            </div>

                        )}

                    </div>

                </div>

            </div>

            {/* UNITÁRIO */}

            <div className="carrinhoItemDesktop-unitario">

                <div className="carrinhoItemDesktop-preco">

                    <strong>

                        R$ {precoUnitario.toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}

                    </strong>

                    {(caixa || pesoPorPeca) && (

                        <span className="carrinhoItemDesktop-porKg">
                            /por kg
                        </span>

                    )}

                </div>

                {caixa && (

                    <div className="carrinhoItemDesktop-descricaoPeso">

                        {quantidade} {quantidade === 1 ? "caixa" : "caixas"} × {pesoCaixa} kg

                    </div>

                )}

                {pesoPorPeca && (

                    <div className="carrinhoItemDesktop-descricaoPeso">

                        {quantidade} {quantidade === 1 ? "peça" : "peças"} × {pesoPeca} kg

                    </div>

                )}

                <div className="carrinhoItemDesktop-controle">

                    <button
                        onClick={diminuir}
                        disabled={saldo <= 0}
                    >
                        -
                    </button>

                    <input
                        type="number"
                        min={1}
                        max={saldo}
                        value={quantidade}
                        disabled={saldo <= 0}
                        onChange={(e) =>
                            alterarQuantidade(e.target.value)
                        }
                    />

                    <button
                        onClick={aumentar}
                        disabled={saldo <= 0}
                    >
                        +
                    </button>

                </div>

                <div className={`carrinhoItemDesktop-mensagem ${tipoMensagem}`}>

                    {saldo <= 0
                        ? "Produto indisponível."
                        : mensagem}

                </div>

            </div>

            {/* TOTAL */}

            <div className="carrinhoItemDesktop-total">

                <strong className="carrinhoItemDesktop-valorTotal">

                    R$ {subtotal.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}

                </strong>

                <button
                    className="carrinhoItemDesktop-remover"
                    onClick={remover}
                >
                    X
                </button>

            </div>

        </article>

    );

}